/**
 * Wrapper for property-scoped settings at /app/property/:propertyId/settings.
 * Syncs selectedPropertyId from URL so Settings page shows that property.
 */

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import SettingsPage from './Settings';
import { Loader2 } from 'lucide-react';

export default function PropertySettingsRoute() {
  const { propertyId } = useParams<{ propertyId: string }>();
  const navigate = useNavigate();
  const { properties, selectProperty, loading } = useApp();

  useEffect(() => {
    if (!propertyId) return;
    selectProperty(propertyId);
  }, [propertyId, selectProperty]);

  const property = properties.find((p) => p.id === propertyId);
  if (!loading && propertyId && !property) {
    navigate('/app/properties', { replace: true });
    return null;
  }

  if (loading && !property) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] gap-2">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <span className="text-sm text-wt-text-secondary">Loading…</span>
      </div>
    );
  }

  return <SettingsPage />;
}
